import { rem } from "polished";
import styled from "styled-components";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const VideoAndParagraphList = withViewportStyle("div")`
  position: relative;  
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${rem(112)};

  ${(props) => props.$viewport.tablet` 
    grid-gap: ${rem(24)};`}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: auto;`}
`;

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  padding: ${rem(80)} ${rem(24)};
  
  ${(props) => props.$viewport.mobile` 
    padding: ${rem(40)} ${rem(16)};`}
`;

export const LeftColumn = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(24)};

  h3,
  p {
    margin-bottom: 0;
  }
`;
